import React from 'react';

import { Skeleton } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';

import { CourseLoaderSkeleton } from '../CourseLoaderSkeleton/CourseLoaderSkeleton';

import s from './CoursesLoader.scss';

export function CoursesLoader(): JSX.Element {
	useStyles(s);
	return (
		<div className="courses-loading" sl-test-data="cmpCoursesLoader">
			<div className="courses-loading__title">
				<Skeleton.Text
					className="courses-loading__title-item"
					width={200}
					size={40}
				/>
			</div>
			<CourseLoaderSkeleton />
		</div>
	);
}
